/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_SpeakersInputs */



/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Event_Group_Sync_Property_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_speakers = /** @type {((inputs?: Event_Group_Sync_Property_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "it") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "es") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Speakers")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Speakers")
	return /** @type {LocalizedString} */ ("Speakers")
});